import { render, staticRenderFns } from "./PokerTable.vue?vue&type=template&id=0d22971a&scoped=true"
import script from "./PokerTable.js?vue&type=script&lang=js&external"
export * from "./PokerTable.js?vue&type=script&lang=js&external"
import style0 from "./PokerTable.vue?vue&type=style&index=0&id=0d22971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22971a",
  null
  
)

export default component.exports